export default __webpack_public_path__ + "static/5-b58b164e032ac213c90d5c4aefd66c3c.png";